import { render, staticRenderFns } from "./BasicPassword.vue?vue&type=template&id=d07380c4&scoped=true&lang=pug"
import script from "./BasicPassword.vue?vue&type=script&lang=js"
export * from "./BasicPassword.vue?vue&type=script&lang=js"
import style0 from "./BasicPassword.vue?vue&type=style&index=0&id=d07380c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07380c4",
  null
  
)

export default component.exports